<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change email</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <div class="flex flex-col gap-4">
        <Input
          v-model="newEmail"
          size="xl"
          type="email"
          label="New email"
          :disabled="loading"
        />
        <Input
          v-model="confirmEmail"
          size="xl"
          type="email"
          label="Confirm email"
          :disabled="loading"
        />
        <Alert v-if="error" variant="error" :icon="AlertIcon">
          {{ error }}
        </Alert>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, Alert, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon, AlertIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeEmail } from './useChangeEmail'

const { close } = useSheet()

defineProps<{
  user: User
}>()

const { newEmail, confirmEmail, error, loading, canSave, save } =
  useChangeEmail()

const handleSave = async () => {
  if (await save()) close()
}
</script>
